import orderBy from "lodash/orderBy";

export interface OrderableProductOption {
  readonly order?: number | null;
}

/**
 * Sorts by the backend-resolved `order` (always alphabetical by name until a product's options are
 * explicitly reordered, per {@link resolveOptionOrder} on the backend). Options missing `order` — only
 * possible with hand-built test fixtures, never real API data — sort last.
 */
export function sortProductOptions<T extends OrderableProductOption>(options: T[]): T[] {
  return orderBy(options, (o) => o.order ?? Number.MAX_SAFE_INTEGER);
}
